<link rel="ractive" href="../r-page.html" name="r-page">
<link rel="ractive" href="../components/header.html" name="c-gp-header">
<link rel="ractive" href="../components/footer.html" name="c-gp-footer">
<link rel="ractive" href="../components/notification.html" name="c-notification">
<link rel="ractive" href="../components/github-md-documents-prefetch.html" name="c-gp-github-md-documents-prefetch">
<link rel="ractive" href="../components/markdown.html" name="c-markdown">

<r-page noYield="{{noYield}}" title="{{title}}" description="{{description}}">
	<c-gp-github-md-documents-prefetch></c-gp-github-md-documents-prefetch>
	<c-notification></c-notification>
	<c-gp-header additionalClasses="header-with-globalping-bg"></c-gp-header>

	<div class="p-privacy-policy">
		<div class="please-wait-sign {{#if @shared.tuText && @shared.ppText && @shared.cpText}} not-displayed{{/if}}">
			Please wait while the document loads.
		</div>

		<div class="dropdown {{#unless @shared.tuText && @shared.ppText && @shared.cpText}} not-displayed{{/unless}}">
			<div class="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
				<span>Navigation</span>
				<div class="toggle-icon">
					<div class="toggle-bar"></div>
					<div class="toggle-bar"></div>
				</div>
			</div>
			<ul class="dropdown-menu">
				<li>
					<div class="dropdown-subtitle">Documents:</div>
				</li>
				<li>
					<a href="/terms/terms-of-use"
						class="dropdown-item {{#if currentPolicy === 'terms-of-use'}}active{{/if}}">
						Terms of Use
					</a>
				</li>
				<li>
					<a href="/terms/privacy-policy"
						class="dropdown-item {{#if currentPolicy === 'privacy-policy'}}active{{/if}}">
						Privacy Policy
					</a>
				</li>
				<li>
					<a href="/terms/cookie-policy"
						class="dropdown-item {{#if currentPolicy === 'cookie-policy'}}active{{/if}}">
						Cookie Policy
					</a>
				</li>
			</ul>
		</div>

		<div class="page-content {{#unless @shared.tuText && @shared.ppText && @shared.cpText}} not-displayed{{/unless}}">
			<div class="page-content_side-menu">
				<div class="menu-section">
					<strong class="section-title">Documents:</strong>

					<div class="section-list">
						<div>
							<a href="/terms/terms-of-use"
								class="{{#if currentPolicy === 'terms-of-use'}}active{{/if}}"
								data-testid="terms-of-use">
									Terms of Use
							</a>
						</div>

						<div>
							<a href="/terms/privacy-policy"
								class="{{#if currentPolicy === 'privacy-policy'}}active{{/if}}"
								data-testid="privacy-policy">
									Privacy Policy
							</a>
						</div>

						<div>
							<a href="/terms/cookie-policy"
								class="{{#if currentPolicy === 'cookie-policy'}}active{{/if}}"
								data-testid="cookie-policy">
									Cookie Policy
							</a>
						</div>
					</div>
				</div>
			</div>

			<div class="page-content_main">
				<h1 class="page-content_main_title">Terms &amp; Policies</h1>

				{{#if currentPolicy === 'privacy-policy'}}
					<c-markdown markdown="{{@shared.ppText}}"></c-markdown>
				{{elseif currentPolicy === 'cookie-policy'}}
					<c-markdown markdown="{{@shared.cpText}}"></c-markdown>
				{{else}}
					<c-markdown markdown="{{@shared.tuText}}"></c-markdown>
				{{/if}}
			</div>
		</div>
	</div>

	<c-gp-footer></c-gp-footer>
</r-page>

<script>
	const listeners = require('../../assets/js/utils/listeners');

	component.exports = {
		data () {
			return {
				title: 'Terms & Policies - Globalping',
				description: 'Learn about the terms of usage of the global network testing platform Globalping.',
				currentPolicy: 'terms-of-use',
			};
		},
		onrender () {
			if (!Ractive.isServer) {
				listeners.stickySidebarScrollListener(this);
			}
		},
	};
</script>
